export default __webpack_public_path__ + "7bef82e6203c6c67dbd3e91119acbc1f.svg";